import { updateInterpolationParams } from '@gig/magic-common';
import { __awaiter, __generator, __assign } from 'tslib';

function setCompetitionParams(competitions) {
    return __awaiter(this, void 0, void 0, function () {
        var paramsAndValues, competitionParams, competitionInterpolationParams;
        return __generator(this, function (_a) {
            paramsAndValues = [];
            competitionParams = [
                'currentProgress',
                'completedMilestones',
                'totalMilestones',
            ];
            competitions.forEach(function (competition) {
                competitionParams.forEach(function (param) {
                    var _a;
                    var calculatedValue;
                    switch (param) {
                        case 'currentProgress':
                            calculatedValue = competition.achievementValue;
                            break;
                        case 'totalMilestones':
                            calculatedValue = (_a = competition.milestones) === null || _a === void 0 ? void 0 : _a.length;
                            break;
                        case 'completedMilestones':
                            calculatedValue = getCompletedMilestones(competition);
                            break;
                    }
                    paramsAndValues.push({
                        parameter: competition.slug + '.' + param,
                        value: calculatedValue,
                    });
                });
            });
            competitionInterpolationParams = paramsAndValues.reduce(function (acc, cur) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[cur.parameter] = cur.value !== undefined ? cur.value.toString() : '', _a)));
            }, {});
            updateInterpolationParams(__assign({}, Object.assign(competitionInterpolationParams)));
            return [2 /*return*/];
        });
    });
}
function getCompletedMilestones(competition) {
    var _a;
    if (competition.milestones && competition.milestones.length > 0) {
        var achievementValue = (_a = competition.achievementValue) !== null && _a !== void 0 ? _a : 0;
        var mileStoneCompleted = 0;
        for (var _i = 0, _b = competition.milestones; _i < _b.length; _i++) {
            var milestone = _b[_i];
            if (achievementValue >= milestone.value) {
                mileStoneCompleted++;
            }
        }
        return mileStoneCompleted;
    }
    else {
        return 0;
    }
}

export { setCompetitionParams };
